import root from 'window-or-global';
import {AlertComponentType} from '../types';

export default function(
    alert: string,
    key: AlertComponentType = AlertComponentType.HIDE_WARNING_BAR
): boolean {
    if (!root) return false;
    try {
        return root.localStorage.getItem(`${key}-${alert}`) !== 'true';
    } catch (err) {
        return false;
    }
}
